import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      onLogin(response.data.token, response.data.user);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2b2b2b 100%)'
      }}
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-96 h-96 bg-[#E04E39] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#E86B5A] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-md p-8">
        <div className="bg-[#242424] border border-white/10 rounded-md p-8 shadow-2xl">
          <div className="flex flex-col items-center mb-8">
            <img 
              src="/logo.png"
              alt="Logo" 
              className="h-16 w-16 mb-4 object-contain"
            />
            <h1 className="text-3xl font-bold text-white tracking-tight mb-2">Equality California</h1>
            <p className="text-sm text-gray-400">Operations Intelligence Platform</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                placeholder="admin@ngo.org"
                className="w-full px-4 py-3 bg-[#1a1a1a] border border-white/10 rounded-md text-white placeholder-gray-600 focus:border-[#E04E39] focus:ring-2 focus:ring-[#E04E39]/20"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                placeholder="Enter your password"
                className="w-full px-4 py-3 bg-[#1a1a1a] border border-white/10 rounded-md text-white placeholder-gray-600 focus:border-[#E04E39] focus:ring-2 focus:ring-[#E04E39]/20"
                required
              />
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/30 rounded-md p-3" data-testid="login-error">
                <p className="text-sm text-red-400">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full px-6 py-3 bg-[#E04E39] hover:bg-[#E86B5A] text-white font-semibold rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">Demo credentials: admin@ngo.org / admin123</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
